module.exports = __webpack_public_path__ + "img/男孩3.03e167dc.png";